import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { CheckCircle, XCircle, Info, X } from 'lucide-react';

const VARIANTS = {
  success: {
    bg: 'bg-green-50',
    border: 'border-green-200',
    text: 'text-green-800',
    icon: CheckCircle,
    iconColor: 'text-green-500',
  },
  error: {
    bg: 'bg-coral-50',
    border: 'border-coral-200',
    text: 'text-coral-800',
    icon: XCircle,
    iconColor: 'text-coral-500',
  },
  info: {
    bg: 'bg-columbia-50',
    border: 'border-columbia-200',
    text: 'text-columbia-800',
    icon: Info,
    iconColor: 'text-columbia-500',
  },
};

function Toast({ type = 'success', message, onClose }) {
  const variant = VARIANTS[type] || VARIANTS.success;
  const Icon = variant.icon;

  useEffect(() => {
    const timer = setTimeout(onClose, 4000);
    return () => clearTimeout(timer);
  }, [onClose]);

  return (
    <motion.div
      initial={{ opacity: 0, y: -20, x: 20 }}
      animate={{ opacity: 1, y: 0, x: 0 }}
      exit={{ opacity: 0, y: -20, x: 20 }}
      transition={{ type: 'spring', stiffness: 400, damping: 30 }}
      className={`flex items-start gap-3 px-5 py-4 rounded-2xl border shadow-elevated max-w-sm ${variant.bg} ${variant.border}`}
    >
      <Icon size={20} className={`${variant.iconColor} flex-shrink-0 mt-0.5`} />
      <p className={`text-sm font-medium flex-1 ${variant.text}`}>{message}</p>
      <button
        onClick={onClose}
        className="text-platinum-400 hover:text-platinum-600 transition-colors flex-shrink-0"
      >
        <X size={16} />
      </button>
    </motion.div>
  );
}

export default Toast;
